import { ModelBase } from '../../core/model/model-base';

export enum SignatureTypeKind {
  BankId = 0,
  Click = 1,
}

export enum InformationChannelKind {
  Email = 0,
  Sms = 1,
  EmailAndSms = 2,
}

export enum SignatureReminderSettingKind {
  NoReminders = 0,
  OnceADay = 1,
}

export enum SigningRoleKind {
  NotSpecified = 1,
  CompanyRepresentative = 2,
  Tenant = 3,
  Guarantor = 4,
}

export class ESignatory extends ModelBase {
  constructor(dataContext?: any) {
    super();
    this.informationChannel = InformationChannelKind.Email;
    this.signingRole = SigningRoleKind.CompanyRepresentative;
    this.signatureType = SignatureTypeKind.BankId;
    this.signatureReminderSetting = SignatureReminderSettingKind.OnceADay;
  }
  signOrder: number;
  signUrl: string;
  informationChannel: InformationChannelKind;
  informationChannelText: string;
  signingRole: SigningRoleKind;
  signatureType: SignatureTypeKind;
  informationSentAt: Date;
  firstReadAt: Date;
  signedAt: Date;
  rejectedAt: Date;
  civicNumber: string;
  email: string;
  phone: string;
  name: string;
  emailDeliveryStatusText: string;
  emailDeliveryInfo: string;
  signatureReminderSetting: SignatureReminderSettingKind;
}
